import angular from "angular"
import "front-end-web-commons"
import "angular-bootstrap"
import "../r2-translate/translate"
import "front-end-web-commons/app/spreadsheetExport/spreadsheetExport"

export default angular.module("spreadsheetModule", ["remoteModule", "ui.bootstrap", "r2TranslateModule", "violationModule", "spreadsheetExportModule"  ])